import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import SalesAnalyticsThumbnail from "./assets/img/Blogs/SalesAnalytics/SalesAnalyticsThumbnail.png";
import AIMLIndianBusinessesThumbnail from "./assets/img/Blogs/AIMLIndianBusinesses/AIMLIndianBusinessesThumbnail.png";
import TechnologyShapingITIndustryThumbnail from "./assets/img/Blogs/TechnologyShapingITIndustry/TechnologyShapingITIndustryThumbnail.png";
import CTOsNeedtoKnowAdoptingAI from "./assets/img/Blogs/CTOsNeedtoKnowAdoptingAI/CTOsNeedtoKnowAdoptingAI.png";
import AIImplementationLeadingHealthcare from "./assets/img/Blogs/AIImplementationLeadingHealthcare/AIImplementationLeadingHealthcare.png";
import ChooseRightITSolutionsProvider from "./assets/img/Blogs/ChooseRightITSolutionsProvider/ChooseRightITSolutionsProvider.png";
import RoleIoTModernEnterpriseSol from "./assets/img/Blogs/RoleIoTModernEnterpriseSol/RoleIoTModernEnterpriseSol.png";
import BenefitsCustomSoftwareArchitecture from "./assets/img/Blogs/BenefitsCustomSoftwareArchitecture/BenefitsCustomSoftwareArchitecture.png";
import FutureAutomationBusinessProcesses from "./assets/img/Blogs/FutureAutomationBusinessProcesses/FutureAutomationBusinessProcesses.png";
import AlertsNotificationsThumbnail from "./assets/img/Blogs/Alerts/Alerts_Banner.png";
import EmbeddedLinuxThumbnail from "./assets/img/Blogs/EmbeddedLinux/Img1.png";
const Blog = () => {
  const gradients = [
    "linear-gradient(to bottom,rgba(156,238,189,.41) 0,rgba(170,200,179,.41) 100%)",
    "linear-gradient(to bottom,rgba(156,205,238,.41) 0,rgba(123,157,170,.41) 100%)",
    "linear-gradient(to bottom,rgba(203,156,238,.41) 0,rgba(197,130,214,.41) 100%)",
    "linear-gradient(to bottom,rgba(238,238,156,.41) 0,rgba(206,210,130,.41) 100%)",
    "linear-gradient(to bottom,rgba(238,156,156,.41) 0,rgba(238,156,156,.41) 1%,rgba(239,171,173,.41) 100%)",
  ];
  return (
    <>
      <Header></Header>
      <div className="mainContent">
        <div className="bannerWrap innerBanner">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9">
                <div className="titleWrap">
                  <h2>Blogs</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogListWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-4 col-sm-6 padLtRt">
                <div
                  className="itemWrap"
                  style={{ backgroundImage: gradients[3] }}
                >
                  <Link to="/WhyEmbeddedLinux">
                    <div className="imgWrap">
                      <img
                        src={EmbeddedLinuxThumbnail}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="dataWrap">
                      <h3>Embedded Linux</h3>
                      <h2>Why Embedded Linux Is Used in Embedded Devices</h2>
                      <div className="metaDataWrap">
                        <div className="blogAuth">
                          <div className="icoWrap"></div>
                          <p>Kunal Mohta</p>
                        </div>
                        <div className="dateWrap">
                          <p>17 Aug 2026</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 padLtRt">
                <div
                  className="itemWrap"
                  style={{ backgroundImage: gradients[4] }}
                >
                  <Link to="/AlertsNotificationsBullMQRedis">
                    <div className="imgWrap">
                      <img
                        src={AlertsNotificationsThumbnail}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="dataWrap">
                      <h3>BullMQ & Redis</h3>
                      <h2>
                        Building a Scalable Alerts and Notifications System with
                        BullMQ and Redis
                      </h2>
                      <div className="metaDataWrap">
                        <div className="blogAuth">
                          <div className="icoWrap"></div>
                          <p>Meghraj Gadhave</p>
                        </div>
                        <div className="dateWrap">
                          <p>3 Aug 2026</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 padLtRt">
                <div
                  className="itemWrap"
                  style={{ backgroundImage: gradients[3] }}
                >
                  <Link to="/FutureAutomationBusinessProcesses">
                    <div className="imgWrap">
                      <img
                        src={FutureAutomationBusinessProcesses}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="dataWrap">
                      <h3>AI vs Traditional IT</h3>
                      <h2>
                        Future of Automation in Business Processes: AI vs.
                        Traditional IT
                      </h2>
                      <div className="metaDataWrap">
                        <div className="blogAuth">
                          <div className="icoWrap"></div>
                          <p>Hummingtec</p>
                        </div>
                        <div className="dateWrap">
                          <p>24 Dec 2025</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 padLtRt">
                <div
                  className="itemWrap"
                  style={{ backgroundImage: gradients[2] }}
                >
                  <Link to="/BenefitsCustomSoftwareArchitecture">
                    <div className="imgWrap">
                      <img
                        src={BenefitsCustomSoftwareArchitecture}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="dataWrap">
                      <h3>Custom Software Architecture</h3>
                      <h2>
                        Benefits of Custom Software Architecture for Scaling
                        Startups
                      </h2>
                      <div className="metaDataWrap">
                        <div className="blogAuth">
                          <div className="icoWrap"></div>
                          <p>Hummingtec</p>
                        </div>
                        <div className="dateWrap">
                          <p>23 Dec 2025</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 padLtRt">
                <div
                  className="itemWrap"
                  style={{ backgroundImage: gradients[1] }}
                >
                  <Link to="/RoleIoTModernEnterpriseSol">
                    <div className="imgWrap">
                      <img
                        src={RoleIoTModernEnterpriseSol}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="dataWrap">
                      <h3>IoT</h3>
                      <h2>The Role of IoT in Modern Enterprise Solutions</h2>
                      <div className="metaDataWrap">
                        <div className="blogAuth">
                          <div className="icoWrap"></div>
                          <p>Hummingtec</p>
                        </div>
                        <div className="dateWrap">
                          <p>2 Dec 2025</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 padLtRt">
                <div
                  className="itemWrap"
                  style={{ backgroundImage: gradients[0] }}
                >
                  <Link to="/ChooseRightITSolutionsProvider">
                    <div className="imgWrap">
                      <img
                        src={ChooseRightITSolutionsProvider}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="dataWrap">
                      <h3>IT solutions provider</h3>

                      <h2>
                        How to Choose the Right IT Solutions Provider for Your
                        Business Needs
                      </h2>
                      <div className="metaDataWrap">
                        <div className="blogAuth">
                          <div className="icoWrap"></div>
                          <p>Hummingtec</p>
                        </div>
                        <div className="dateWrap">
                          <p>2 Dec 2025</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 padLtRt">
                <div
                  className="itemWrap"
                  style={{ backgroundImage: gradients[4] }}
                >
                  <Link to="/AIImplementationLeadingHealthcare">
                    <div className="imgWrap">
                      <img
                        src={AIImplementationLeadingHealthcare}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="dataWrap">
                      <h3>Artificial Intelligence (AI)</h3>
                      <h2>
                        Case Study: AI Implementation for a Leading Healthcare
                        Provider
                      </h2>
                      <div className="metaDataWrap">
                        <div className="blogAuth">
                          <div className="icoWrap"></div>
                          <p>Hummingtec</p>
                        </div>
                        <div className="dateWrap">
                          <p>1 Dec 2025</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 padLtRt">
                <div
                  className="itemWrap"
                  style={{ backgroundImage: gradients[3] }}
                >
                  <Link to="/CTOsNeedtoKnowAdoptingAI">
                    <div className="imgWrap">
                      <img
                        src={CTOsNeedtoKnowAdoptingAI}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="dataWrap">
                      <h3>Artificial Intelligence (AI)</h3>
                      <h2>
                        What CTOs Need to Know Before Adopting AI in Their
                        Organization
                      </h2>
                      <div className="metaDataWrap">
                        <div className="blogAuth">
                          <div className="icoWrap"></div>
                          <p>Hummingtec</p>
                        </div>
                        <div className="dateWrap">
                          <p>1 Dec 2025</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 padLtRt">
                <div
                  className="itemWrap"
                  style={{ backgroundImage: gradients[2] }}
                >
                  <Link to="/TechnologyShapingITIndustry">
                    <div className="imgWrap">
                      <img
                        src={TechnologyShapingITIndustryThumbnail}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="dataWrap">
                      <h3>IT Industry in 2025</h3>
                      <h2>
                        Top 5 Technology Trends Shaping the IT Industry in 2025
                      </h2>
                      <div className="metaDataWrap">
                        <div className="blogAuth">
                          <div className="icoWrap"></div>
                          <p>Hummingtec</p>
                        </div>
                        <div className="dateWrap">
                          <p>21 Nov 2025</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 padLtRt">
                <div
                  className="itemWrap"
                  style={{ backgroundImage: gradients[1] }}
                >
                  <Link to="/AIMLIndianBusinesses">
                    <div className="imgWrap">
                      <img
                        src={AIMLIndianBusinessesThumbnail}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="dataWrap">
                      <h3>AI and Machine Learning</h3>
                      <h2>
                        How AI and Machine Learning Solutions Are Transforming
                        Indian Businesses
                      </h2>
                      <div className="metaDataWrap">
                        <div className="blogAuth">
                          <div className="icoWrap"></div>
                          <p>Hummingtec</p>
                        </div>
                        <div className="dateWrap">
                          <p>21 Nov 2025</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 padLtRt">
                <div
                  className="itemWrap"
                  style={{ backgroundImage: gradients[0] }}
                >
                  <Link to="/TransformSalesDataIntoRevenue">
                    <div className="imgWrap">
                      <img
                        src={SalesAnalyticsThumbnail}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="dataWrap">
                      <h3>Sales Analytics</h3>
                      <h2>
                        Transform Your Sales Data Into Revenue-Driving Insights
                      </h2>
                      <div className="metaDataWrap">
                        <div className="blogAuth">
                          <div className="icoWrap"></div>
                          <p>Hummingtec</p>
                        </div>
                        <div className="dateWrap">
                          <p>23 Sep 2025</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>

              {/* 



              

              <div className="col-md-4 col-sm-6 padLtRt">
                <div
                  className="itemWrap"
                  style={{ backgroundImage: gradients[2] }}
                >
                  <Link to="">
                    <div className="imgWrap"></div>
                    <div className="dataWrap">
                      <h3>Automation</h3>
                      <h2>
                        Future of Automation in Business Processes: AI vs.
                        Traditional IT
                      </h2>
                      <div className="metaDataWrap">
                        <div className="blogAuth">
                          <div className="icoWrap"></div>
                          <p>Hummingtec</p>
                        </div>
                        <div className="dateWrap">
                          <p>13 Aug 2025</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};
export default Blog;
